module.exports = __webpack_public_path__ + "img/tejesol-logo-normal.f4555588.png";